import React, { use, useEffect, useRef, useState } from "react";
import "../styles/Layout.scss";
import {
  NavLink,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import logo from "../assets/logo.png";
import ResetPassword from "../pages/ResetPassword";
import CreateUser from "../pages/CreateUser";
import EditUser from "../pages/EditUser";
import Users from "../pages/Users";
import Requisitions from "../pages/Requisitions";
import CreateRequisition from "../pages/CreateRequisition";
import EditRequisition from "../pages/EditRequisition";
import UpdateRequisition from"../pages/UpdateRequisition";
import AssignedList from "../pages/AssignedList";
import AssignCandidate from "../pages/AssignCandidate";
import HiringManagerDashboard from "../pages/HiringManagerDashboard";
import Skills from "../pages/settings/Skills";
import Departments from "../pages/settings/Departments";
import Locations from "../pages/settings/Locations";
import JobType from "../pages/settings/JobType";
import EducationQualification from "../pages/settings/EducationQualification.jsx";
import Statuses from "../pages/settings/Status";
import Candidates from "../pages/Candidates";
import CreateCandidate from "../pages/CreateCandidate";
import EditCandidate from "../pages/EditCandidate";
import Logs from "../pages/Logs";
import CreateClient from "../pages/CreateClient";
import EditClient from "../pages/EditClient";
import Clients from "../pages/Clients";
// import ClientsReport from "../pages/ClientsReport";
import RecruiterReport from "../pages/RecruiterReport";
import FinalSummary from "../pages/FinalSummary";
import DailyReport from "../pages/reports/DailyReport";
import MonthlyReport from "../pages/reports/MonthlyReport";
import RequirementsReport from "../pages/reports/RequirementsReport";
import UsersByReport from "../pages/reports/UsersByReport";
import StatusByReport from "../pages/reports/StatusByReport";
import WeeklyReport from "../pages/reports/WeeklyReport";
import SixthsenseRawCandidateDetails from "../pages/settings/SixthsenseRawCandidateDetails.jsx";
function Layout() {
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [settingsDropdownOpen, setSettingsDropdownOpen] = useState(false);
  const [reportsDropdownOpen, setReportsDropdownOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 1036);
  const profileDropdownRef = useRef(null);
  const settingsDropdownRef = useRef(null);
  const reportsDropdownRef = useRef(null);
  const sidebarRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  // Get role_id from localStorage
  const [roleId, setRoleID] = useState(null);

  // Function to determine if we're in mobile view
  const checkIsMobile = () => {
    return window.innerWidth <= 1036; // Match the CSS breakpoint
  };

  // Get user data from localStorage
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const userName = userData?.user?.name || "User";

  // Get the first letter of the user's name for profile icon
  // Fallback to '--' if user data is not available
  const userNameInitial = userName.charAt(0).toUpperCase();

  // Function to get role name based on role_id
  const getRoleName = (roleId) => {
    if (!roleId) return "Loading...";

    switch (roleId) {
      case "1":
        return "Admin";
      case "3":
        return "Hiring Manager";
      case "4":
        return "Recruiter";
      default:
        return "";
    }
  };

  //
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target)
      ) {
        setProfileDropdownOpen(false);
      }
      if (
        settingsDropdownRef.current &&
        !settingsDropdownRef.current.contains(event.target)
      ) {
        setSettingsDropdownOpen(false);
      }
      if (
        reportsDropdownRef.current &&
        !reportsDropdownRef.current.contains(event.target)
      ) {
        setReportsDropdownOpen(false);
      }
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle window resize events
  useEffect(() => {
    const handleResize = () => {
      const mobile = checkIsMobile();
      setIsMobile(mobile);

      // If switching to desktop, close sidebar
      if (!mobile) {
        setSidebarOpen(false);
      }
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Close sidebar on route change (only on mobile)
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  }, [location, isMobile]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // No smooth scrolling
    });
  }, [navigate]);

  useEffect(() => {
    const roleID = localStorage.getItem("role_id");
    console.log("roleID from localStorage:", roleID);
    if (!roleID) {
      navigate("/login");
    } else {
      setRoleID(roleID);
      console.log("Setting roleId to:", roleID);
    }
  }, [navigate]);

  return (
    <div className="layout">
      {/* Single navbar that adapts based on screen size */}
      <nav className="navbar">
        <img
          src={logo}
          alt="UpwarqIQSuite"
          className="logo"
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (roleId === "1") {
              navigate("/dashboard");
            } else if (roleId === "3") {
              navigate("/hiring-manager-dashboard");
            } else if (roleId === "4") {
              navigate("/requisitions");
            } else {
              navigate("/");
            }
          }}
        />
        <ul className="nav-links">
          {(roleId === "1" || roleId === "3") && (
            <li>
              <NavLink
                to={roleId === "1" ? "/dashboard" : "/hiring-manager-dashboard"}
              >
                Dashboard
              </NavLink>
            </li>
          )}
          {roleId !== "3" && roleId !== "4" && (
            <li>
              <NavLink to="/users">Users</NavLink>
            </li>
          )}
          {roleId !== "4" && (
            <li>
              <NavLink to="/clients">Clients</NavLink>
            </li>
          )}
          <li>
            <NavLink to="/requisitions">Requisitions</NavLink>
          </li>
          <li>
            <NavLink to="/candidates">Candidates</NavLink>
          </li>
          {/* Show Skills as main menu for Recruiter (role_id 4) */}
          {roleId === "4" && (
            <li>
              <NavLink to="/settings/skills">Skills</NavLink>
            </li>
          )}
          {/* <li>
            <NavLink to="/logs">Logs</NavLink>
          </li> */}
          {/* Hide Users menu for Hiring Manager (3) and Recruiter (4) */}

          {roleId !== "4" && (
            <li className="reports-nav-item" ref={reportsDropdownRef}>
              <span
                className={
                  reportsDropdownOpen ? "reports-text active" : "reports-text"
                }
                onClick={() => setReportsDropdownOpen((v) => !v)}
                tabIndex={0}
                style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}
              >
                Reports
                <svg
                  className={
                    reportsDropdownOpen ? "chevron-icon open" : "chevron-icon"
                  }
                  width="16"
                  height="16"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ transition: "transform 0.2s" }}
                >
                  <path
                    d="M6 8l4 4 4-4"
                    stroke="#222"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              {reportsDropdownOpen && (
                <div
                  className="reports-dropdown"
                  onMouseLeave={() => setReportsDropdownOpen(false)}
                >
                  {/* <NavLink
                  className="px-2"
                  to="/dailyreport"
                  onClick={() => setReportsDropdownOpen(false)}
                >
                  Daily Report
                </NavLink> */}
                  <NavLink
                    className="px-2"
                    to="/weeklyreport"
                    onClick={() => setReportsDropdownOpen(false)}
                  >
                    Weekly Report
                  </NavLink>
                  <NavLink
                    className="px-2"
                    to="/monthlyreport"
                    onClick={() => setReportsDropdownOpen(false)}
                  >
                    Monthly Report
                  </NavLink>
                  <NavLink
                    className="px-2"
                    to="/userbyreport"
                    onClick={() => setReportsDropdownOpen(false)}
                  >
                    User By Report
                  </NavLink>
                  <NavLink
                    className="px-2"
                    to="/requirementsreport"
                    onClick={() => setReportsDropdownOpen(false)}
                  >
                    Requirements Report
                  </NavLink>
                  <NavLink
                    className="px-2"
                    to="/statusbyreport"
                    onClick={() => setReportsDropdownOpen(false)}
                  >
                    Status By Report
                  </NavLink>
                  {/* <NavLink
                  className="px-2"
                  to="/clientsreport"
                  onClick={() => setReportsDropdownOpen(false)}
                >
                  Clients Report
                </NavLink>
                <NavLink
                  className="px-2"
                  to="/recruiterreport"
                  onClick={() => setReportsDropdownOpen(false)}
                >
                  Recruiter Report
                </NavLink> */}
                  {/* <NavLink
                  className="px-2"
                  to="/finalsummary"
                  onClick={() => setReportsDropdownOpen(false)}
                >
                  Final Summary
                </NavLink> */}
                </div>
              )}
            </li>
          )}
          <li className="settings-nav-item" ref={settingsDropdownRef}>
            <span
              className={
                settingsDropdownOpen ? "settings-text active" : "settings-text"
              }
              onClick={() => setSettingsDropdownOpen((v) => !v)}
              tabIndex={0}
              style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}
            >
              More
              <svg
                className={
                  settingsDropdownOpen ? "chevron-icon open" : "chevron-icon"
                }
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ transition: "transform 0.2s" }}
              >
                <path
                  d="M6 8l4 4 4-4"
                  stroke="#222"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            {settingsDropdownOpen && (
              <div
                className="settings-dropdown"
                onMouseLeave={() => setSettingsDropdownOpen(false)}
              >
                {/* Hide Skills from More dropdown for Recruiter (role_id 4) - shown as main menu */}
                {roleId !== "4" && (
                  <NavLink
                    className="px-2"
                    to="/settings/skills"
                    onClick={() => setSettingsDropdownOpen(false)}
                  >
                    Skills
                  </NavLink>
                )}
                {roleId !== "4" && (
                  <NavLink
                    className="px-2"
                    to="/settings/locations"
                    onClick={() => setSettingsDropdownOpen(false)}
                  >
                  Locations
                </NavLink>)}


                    {roleId !== "4" && (
                 <NavLink
                   className="px-2"
                   to="/settings/education-qualification"
                   onClick={() => setSettingsDropdownOpen(false)}
                  >
                  Education Qualification
                  </NavLink>)}  

                
                 {roleId !== "4" && (
                 <NavLink
                   className="px-2"
                   to="/settings/SixthsenseRawCandidateDetails"
                   onClick={() => setSettingsDropdownOpen(false)}
                  >
                  SixthsenseRawCandidates
                  </NavLink>)}



                {/* <NavLink
                  className="px-2"
                  to="/settings/statuses"
                  onClick={() => setSettingsDropdownOpen(false)}
                >
                  Status
                </NavLink> */}
                {/* Hide Job Type for Recruiter (role_id 4) */}
                {roleId !== "4" && (
                  <NavLink
                    className="px-2"
                    to="/settings/job-type"
                    onClick={() => setSettingsDropdownOpen(false)}
                  >
                    Job Type
                  </NavLink>
                )}
                <NavLink
                  className="px-2"
                  to="/settings/department"
                  onClick={() => setSettingsDropdownOpen(false)}
                >
                  Department
                </NavLink>
              </div>
            )}
          </li>
        </ul>
        <div className="navbar-right">
          <div className="profile-section" ref={profileDropdownRef}>
            <div
              className="profile-icon"
              onClick={() => setProfileDropdownOpen((v) => !v)}
            >
              {userNameInitial}
            </div>
            {profileDropdownOpen && (
              <div className="profile-dropdown">
                <div className="user-info">
                  <div className="user-name">{userName}</div>
                  <div className="user-role">Role: {getRoleName(roleId)}</div>
                </div>
                <div className="dropdown-divider"></div>
                <NavLink to="/reset-password">Reset Password</NavLink>
                <button
                  onClick={() => {
                    localStorage.clear();
                    navigate("/");
                  }}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
          <button
            className="hamburger"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      {/* Sidebar (offcanvas) - only on mobile */}
      {isMobile && (
        <div
          className={`mobile-sidebar${sidebarOpen ? " open" : ""}`}
          ref={sidebarRef}
          tabIndex="-1"
          aria-labelledby="mobileSidebarLabel"
        >
          <div className="sidebar-header">
            <h5 id="mobileSidebarLabel"></h5>
            <button
              className="close-btn"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close menu"
            >
              &times;
            </button>
          </div>
          <ul className="sidebar-links">
            {/* Dashboard link - navigates based on role */}
            {(roleId === "1" || roleId === "3") && (
              <li>
                <NavLink
                  to={
                    roleId === "1" ? "/dashboard" : "/hiring-manager-dashboard"
                  }
                >
                  Dashboard
                </NavLink>
              </li>
            )}
            {roleId !== "3" && roleId !== "4" && (
              <li>
                <NavLink to="/users">Users</NavLink>
              </li>
            )}
            {roleId !== "4" && (
              <li>
                <NavLink to="/clients">Clients</NavLink>
              </li>
            )}
            <li>
              <NavLink to="/requisitions">Requisitions</NavLink>
            </li>
            <li>
              <NavLink to="/candidates">Candidates</NavLink>
            </li>
            {roleId !== "4" && (
              <li className="sidebar-reports">
                <span>Reports</span>
                <ul className="sidebar-reports-dropdown">
                  {/* <li>
                      <NavLink to="/dailyreport">Daily Report</NavLink>
                    </li> */}
                  <li>
                    <NavLink to="/weeklyreport">Weekly Report</NavLink>
                  </li>
                  <li>
                    <NavLink to="/monthlyreport">Monthly Report</NavLink>
                  </li>
                  <li>
                    <NavLink to="/userbyreport">User By Report</NavLink>
                  </li>
                  <li>
                    <NavLink to="/requirementsreport">
                      Requirement Report
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/statusbyreport">Status By Report</NavLink>
                  </li>
                  {/* <li>
                      <NavLink to="/clientsreport">Clients Report</NavLink>
                </li>
                <li>
                  <NavLink to="/recruiterreport">Recruiter Report</NavLink>
                </li>
                <li>
                  <NavLink to="/finalsummary">Final Summary</NavLink>
                </li> */}
                </ul>
              </li>
            )}
            {/* Show Skills as main menu for Recruiter (role_id 4) */}
            {roleId === "4" && (
              <li>
                <NavLink to="/settings/skills">Skills</NavLink>
              </li>
            )}
            {/* <li>
              <NavLink to="/logs">Logs</NavLink>
            </li> */}

            {/* Hide Users menu for Hiring Manager (3) and Recruiter (4) */}

            <li className="sidebar-settings">
              <span>More</span>
              <ul className="sidebar-settings-dropdown">
                {/* Hide Skills from More dropdown for Recruiter (role_id 4) - shown as main menu */}
                {roleId !== "4" && (
                  <li>
                    <NavLink to="/settings/skills">Skills</NavLink>
                  </li>
                )}
                <li>
                  <NavLink to="/settings/locations">Locations</NavLink>
                </li>
                <li>
                  <NavLink to="/settings/statuses">Status</NavLink>
                </li>
                {/* Hide Job Type for Recruiter (role_id 4) */}
                {roleId !== "4" && (
                  <li>
                    <NavLink to="/settings/job-type">Job Type</NavLink>
                  </li>
                )}
                <li>
                  <NavLink to="/settings/department">Department</NavLink>
                </li>
                <li>
                  <NavLink to="/settings/education-qualification">Education Qualification</NavLink>
                </li>

                 <li>
                  <NavLink to="/settings/SixthsenseRawCandidateDetails">SixthsenseRawCandidates</NavLink>
                </li>

              </ul>
            </li>
          </ul>
        </div>
      )}

      {/* Overlay for sidebar - only on mobile */}
      {isMobile && sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      {/* Routes for all pages */}
      <main className="main-content">
        <Routes>
          <Route path="dashboard" element={<Dashboard />} />
          <Route
            path="hiring-manager-dashboard"
            element={<HiringManagerDashboard />}
          />
          <Route path="users/create" element={<CreateUser />} />
          <Route path="users/edit/:id" element={<EditUser />} />
          <Route path="users" element={<Users />} />
          <Route path="clients/create" element={<CreateClient />} />
          <Route path="clients/edit/:id" element={<EditClient />} />
          <Route path="clients" element={<Clients />} />
          <Route path="requisitions" element={<Requisitions />} />
          <Route path="requisitions/create" element={<CreateRequisition />} />
          <Route path="requisitions/edit/:id" element={<EditRequisition />} />
          <Route path="requisitions/update/:id" element={<UpdateRequisition />} />
          <Route path="requisitions/assign" element={<AssignCandidate />} />
          <Route path="requisitions/assignedlist" element={<AssignedList />} />
          <Route path="settings/skills" element={<Skills />} />
          <Route path="settings/department" element={<Departments />} />
          <Route path="settings/locations" element={<Locations />} />
          <Route path="settings/job-type" element={<JobType />} />
          <Route path="settings/education-qualification" element={<EducationQualification />} />
          <Route path="settings/statuses" element={<Statuses />} />
          <Route path="candidates" element={<Candidates />} />
          <Route path="candidates/create" element={<CreateCandidate />} />
          <Route path="candidates/edit/:id" element={<EditCandidate />} />
          <Route path="logs" element={<Logs />} />
          <Route path="userbyreport" element={<UsersByReport />} />
          <Route path="statusbyreport" element={<StatusByReport />} />
          <Route path="dailyreport" element={<DailyReport />} />
          <Route path="monthlyreport" element={<MonthlyReport />} />
          <Route path="weeklyreport" element={<WeeklyReport />} />
          <Route path="requirementsreport" element={<RequirementsReport />} />
          <Route path="finalsummary" element={<FinalSummary />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="settings/SixthsenseRawCandidateDetails" element={<SixthsenseRawCandidateDetails />} />
          {/* <Route path="settings/SixthsenseRawCandidateDetails/:candidateId" element={<SixthsenseRawCandidateDetails />} /> */}
        </Routes>
      </main>
    </div>
  );
}

export default Layout;
